<template>
  <el-row>
    <el-card class="card-horizontal completed-card" v-loading="isLoading">
      <a class="module__link" v-on:click="enrollAndStartCourse">
        <el-row :gutter="20">
          <el-col :xs="{ span: 12, offset: 6 }" :sm="8" :md="4">
            <div class="card-horizontal__media">
              <img v-if="course.bigImage" :src="course.bigImage">
              <img v-else :src="fallbackJpg">
            </div>
          </el-col>
          <el-col :xs="24" :sm="16" :md="20">
            <header class="card-horizontal__header">
              <h4 class="h4 font-family-body"><img class="completed-check" :src="checkImage" />{{ course.title }}</h4>
              <div v-if="course.fullLine">
                <img :src="fullLineRibbon" />
                <span class="full-line-title">
                  {{ course.fullLine }}
                </span>
              </div>
              <h4 class="h6 font-family-body">{{ $t('trainingModuleCompletedDateLabel') }}&nbsp;{{ usersCourse.completed
              }}</h4>
            </header>
            <div class="card-horizontal__actions">
              <span v-if="usersCourse.certificateUrl" class="card-horizontal__link-emphasized">{{
                  $t('trainingModuleCompleteCardCertCta')
              }}</span>
              <span v-else-if="course.isFullLineSummary" class="card-horizontal__link-emphasized">{{
                  $t('trainingModuleCompleteCardSummaryCta')
              }}</span>
              <span v-else class="card-horizontal__link-emphasized">{{ $t('trainingModuleCompleteCardCta') }}</span>
            </div>
          </el-col>
        </el-row>
      </a>
    </el-card>
  </el-row>
</template>

<script>
import api from '@/api';
import fallbackJpg from '@/assets/images/fallbackSquare.jpg';
import router from '@/router';
import checkImage from '@/assets/images/green-check.svg';
import fullLineRibbon from '@/assets/images/full-line-ribbon.svg';
import loadingStateReset from '@/mixins/loadingStateReset';

export default {
  name: 'TrainingCompletedCard',
  mixins: [loadingStateReset],
  data() {
    return {
      fallbackJpg,
      fullLineRibbon,
      checkImage,
      isLoading: false,
    }
  },
  props: {
    course: Object,
    usersCourse: Object,
  },
  methods: {
    enrollAndStartCourse: function (event) {
      this.isLoading = true;
      api.get('/actions/mercury/talent-lms/enroll?course=' + this.course.id)
        .then(function (response) {
          window.location.href = response.url;
        })
        .catch(function (error) {
          log.error(error);
        });
    },
  }
};
</script>

<style lang="scss" scoped>

</style>

<style lang="scss">
@import 'element-theme-chalk/src/mixins/mixins.scss';

.module {
  &__link {
    overflow: hidden;
    display: block;
    position: relative;
    width: 100%;
    height: 100%;
    cursor: pointer;
    text-decoration: none;
  }
}

.card-horizontal {
  &__link-locked::after {
    content: none;
  }

  .card-horizontal__media {
    @include res(xs) {
      margin-bottom: 30px;
    }

    @include res(md) {
      margin-top: 10px;
    }

    img {
      object-position: bottom;
      object-fit: contain;
    }
  }
}

.completed-check {
  width: 20px;
  position: relative;
  margin-right: 10px;
  top: 4px;
}

.full-line-title {
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 16px;
  color: #D31F25;
  text-transform: uppercase;
  vertical-align: text-top;
}
</style>